// @flow
import { getCreator, postCreator, putCreator, deleteCreator } from '../../http';
import environment from '../../environment';
import { of } from 'rxjs';

export const endpoints = Object.freeze({
  GET_USER_WISH_LISTS: `${environment.apiUrl}/wishlist/user-list`,
  POST_USER_WISH_LIST: `${environment.apiUrl}/wishlist`,
  PUT_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:userId/:slug`,
  DELETE_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:userId/:slug`,
  UPLOAD_IMAGE: `${environment.apiUrl}/image/upload`,
  UPLOAD_IMAGE_URL: `${environment.apiUrl}/image/upload/url`,
});

export const getUserWishListsApi = getCreator(fetch, endpoints.GET_USER_WISH_LISTS);
export const postUserWishListsApi = postCreator(fetch, endpoints.POST_USER_WISH_LIST);
export const putUserWishListsApi = putCreator(fetch, endpoints.PUT_USER_WISH_LIST);
export const deleteUserWishListsApi = deleteCreator(fetch, endpoints.DELETE_USER_WISH_LIST);
export const uploadImageApi = postCreator(fetch, endpoints.UPLOAD_IMAGE);
export const uploadImageURLApi = postCreator(fetch, endpoints.UPLOAD_IMAGE_URL);



// WEBPACK FOOTER //
// ./src/modules/my-wish-lists/api.js